export default function DifficultyStars({ value = 1, max = 5 }) {
  return (
    <span title={`Schwierigkeit: ${value}/${max}`}>
      {Array.from({ length: max }, (_, i) => (
        <i
          key={i}
          className={`bi ${i < value ? 'bi-star-fill' : 'bi-star'} text-warning`}
          style={{ fontSize: '0.85rem' }}
        />
      ))}
    </span>
  );
}
